module.exports = __webpack_public_path__ + "1792395595471/images/32px.e1d0c01.png";